<div class="filters-card">
  <div class="filters-header">
    <div class="filters-heading">
      <div class="filters-title">
        <mat-icon class="filters-title-icon">tune</mat-icon>
        <span>Filtros</span>
        <span class="filters-count" *ngIf="activeFilterChips.length">{{ activeFilterChips.length }}</span>
      </div>
      <p class="filters-subtitle">Busca por prefijo de file o itinerario y refina sin cargar todos los files.</p>
    </div>

    <button
      *ngIf="hasActiveFilters"
      type="button"
      mat-stroked-button
      class="btn-clear-all"
      (click)="clearAllFilters.emit()"
    >
      <mat-icon>filter_alt_off</mat-icon>
      Limpiar filtros
    </button>
  </div>

  <div class="filters-row">
    <div class="search-filter-cell">
      <mat-form-field appearance="outline" class="filter-field filter-search">
        <mat-label>Buscar #file o nombre de itinerario</mat-label>
        <mat-icon
          matPrefix
          class="field-prefix-icon"
          matTooltip="Búsqueda limitada por prefijo de file o nombre de itinerario"
        >search</mat-icon>
        <input
          matInput
          type="search"
          autocomplete="off"
          placeholder="Ej. 202501234 o Machu"
          [(ngModel)]="searchValue"
          (ngModelChange)="onSearchChange($event)"
          (keyup.enter)="filterQueued.emit()"
        />
        <button
          *ngIf="searchValue"
          mat-icon-button
          matSuffix
          type="button"
          class="search-clear-suffix"
          aria-label="Limpiar búsqueda"
          (click)="onSearchChange('')"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <span *ngIf="searchValidationMessage" class="search-validation-message">
        {{ searchValidationMessage }}
      </span>
      <span *ngIf="!searchValidationMessage" class="search-helper-message">
        Texto por itinerario o mínimo 4 dígitos para número de file
      </span>
    </div>

    <div class="client-filter-cell">
      <mat-form-field appearance="outline" class="filter-field filter-client">
        <mat-label>Cliente</mat-label>
        <mat-icon matPrefix class="field-prefix-icon">business</mat-icon>
        <input
          matInput
          type="text"
          autocomplete="off"
          placeholder="Buscar cliente"
          [ngModel]="clientSearchValue"
          (ngModelChange)="onClientSearchChange($event)"
          [matAutocomplete]="clientAutocomplete"
        />
        <button
          *ngIf="selectedNameClient || clientSearchValue"
          mat-icon-button
          matSuffix
          type="button"
          class="client-clear-suffix"
          aria-label="Limpiar cliente"
          (click)="clearClientFilter()"
        >
          <mat-icon>close</mat-icon>
        </button>
        <mat-autocomplete #clientAutocomplete="matAutocomplete" (optionSelected)="onClientSelected($event.option.value)">
          <mat-option *ngIf="isLoadingClients" disabled>Cargando clientes...</mat-option>
          <mat-option *ngIf="!isLoadingClients && !clientOptions.length" disabled>Sin clientes disponibles</mat-option>
          <mat-option
            *ngFor="let client of clientOptions; trackBy: trackByClient"
            [value]="client"
          >{{ client }}</mat-option>
        </mat-autocomplete>
      </mat-form-field>
      <span class="client-helper-message">Filtro exacto por cliente</span>
    </div>

    <mat-form-field appearance="outline" class="filter-field filter-select">
      <mat-label>Año</mat-label>
      <mat-icon matPrefix class="field-prefix-icon">event</mat-icon>
      <mat-select
        [value]="fileYear ?? ''"
        (selectionChange)="onYearChange($event.value)"
      >
        <mat-option value="">Todos los años</mat-option>
        <mat-option
          *ngFor="let yearFile of availableYears; trackBy: trackByYear"
          [value]="yearFile"
        >{{ yearFile }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-field filter-select">
      <mat-label>Estado</mat-label>
      <mat-icon matPrefix class="field-prefix-icon">flag</mat-icon>
      <mat-select
        [value]="fileStatus ?? ''"
        (selectionChange)="onStatusChange($event.value)"
      >
        <mat-option value="">Todos los estados</mat-option>
        <mat-option
          *ngFor="let state of fileStates; trackBy: trackByState"
          [value]="state"
        >{{ state }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" class="filter-field filter-date">
      <mat-label>Fecha operación</mat-label>
      <mat-icon matPrefix class="field-prefix-icon">date_range</mat-icon>
      <mat-date-range-input [rangePicker]="startDateFileRangePicker" (dateChange)="onDateRangeChange()">
        <input matStartDate placeholder="Desde" [(ngModel)]="startDateFileRange.start" />
        <input matEndDate placeholder="Hasta" [(ngModel)]="startDateFileRange.end" />
      </mat-date-range-input>
      <button
        *ngIf="startDateFileRange.start || startDateFileRange.end"
        mat-icon-button
        matSuffix
        type="button"
        class="date-clear-suffix"
        aria-label="Limpiar fecha de operación"
        (click)="clearDateRange.emit('startDateFileRange')"
      >
        <mat-icon>close</mat-icon>
      </button>
      <mat-datepicker-toggle matSuffix [for]="startDateFileRangePicker"></mat-datepicker-toggle>
      <mat-date-range-picker #startDateFileRangePicker></mat-date-range-picker>
    </mat-form-field>

  </div>

  <div class="filters-footer">
    <div class="active-filters-row" [class.empty]="!activeFilterChips.length">
      <ng-container *ngIf="activeFilterChips.length; else noActiveFilters">
        <span class="active-filters-label">Activos:</span>
        <div class="active-filters-chips">
          <span class="filter-chip" *ngFor="let chip of activeFilterChips; trackBy: trackByChip">
            <span class="filter-chip-text">{{ chip.label }}</span>
            <button
              type="button"
              class="filter-chip-remove"
              (click)="removeFilter.emit(chip.id)"
              [attr.aria-label]="'Quitar filtro ' + chip.label"
            >
              <mat-icon>close</mat-icon>
            </button>
          </span>
        </div>
      </ng-container>
      <ng-template #noActiveFilters>
        <span class="active-filters-placeholder">Sin filtros activos</span>
      </ng-template>
    </div>

  </div>
</div>
